<div class="back mb15">
  <i class="db-icon db-icon-ds-arrow-small" (click)="onStepChange.emit('features')"></i>
  <h2>Get 10Web Pro plans</h2>
</div>
<ng-container *ngIf="mode !== 'pro-level'"><db-one-month-free-select-plan [isAgency]="isAgency" (onPlanChange)="onPlanChange.emit($event)"></db-one-month-free-select-plan></ng-container>

<ng-container *ngIf="mode === 'pro-level'"><db-booster-pro-select-plan (onPlanChange)="onPlanChange.emit($event)"></db-booster-pro-select-plan></ng-container>

<hr>

<div class="due-today mt20 mb10">
  <p>
    <b>Due today</b>
  </p>
  <b>${{chosenPlan?.price}}</b>
</div>
<p class="mb30" *ngIf="chosenPlan?.price > 0">Then pay ${{chosenPlan?.price}} each {{chosenPlan?.type}} beginning on
  {{expirationDate | date: 'MMM d, y'}}
  until you cancel your subscription.</p>
<div class="text-center buttons-wrap">
  <button class="ds-btn-blue ds-btn-xl rectangle" (click)="proceedToCheckout()">
    <span>{{'proceed' | lowerCaseSpecificWords}}</span>
  </button>
</div>
